import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import ActionButton from '../components/ActionButton';

export default function Hakedisler() {
  const [hakedisler, setHakedisler] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/hakedis/');
      setHakedisler(res.data);
    } catch (err) {
      console.error('Yükleme hatası:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const handleDelete = async (h) => {
    const msg = h.status === 'final'
      ? 'Hakedişi silmek istediğinize emin misiniz? Depodan düşülen ürünler iptal hareketiyle stoğa geri eklenecek.'
      : 'Hakedişi silmek istediğinize emin misiniz?';
    if (!window.confirm(msg)) return;
    try {
      await api.delete(`/api/hakedis/${h.id}`);
    } catch (err) {
      alert('Hata: ' + JSON.stringify(err.response?.data?.detail || 'Silinemedi'));
    }
    reload();
  };

  const handlePdf = async (hakedisId, hakedisNumber, mode) => {
    try {
      const res = await api.get(`/api/hakedis/${hakedisId}/pdf?mode=${mode}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `${hakedisNumber}${mode === 'comparison' ? '_karsilastirmali' : ''}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch {
      alert('PDF oluşturulamadı');
    }
  };

  const handleExcel = async (hakedisId, hakedisNumber, mode) => {
    try {
      const res = await api.get(`/api/hakedis/${hakedisId}/excel?mode=${mode}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `${hakedisNumber}${mode === 'comparison' ? '_karsilastirmali' : ''}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch {
      alert('Excel oluşturulamadı');
    }
  };

  const statusLabel = (s) => {
    const map = { draft: 'Taslak', final: 'Kesinleşti' };
    const colors = { draft: 'bg-gray-100 text-gray-600', final: 'bg-green-100 text-green-700' };
    return <span className={`text-xs px-2 py-1 rounded font-medium ${colors[s] || 'bg-gray-100 text-gray-600'}`}>{map[s] || s}</span>;
  };

  if (loading) return (
    <div className="flex items-center justify-center py-20">
      <div className="text-gray-400 text-center">
        <div className="text-3xl mb-2">⏳</div>
        <div>Hakedişler yükleniyor...</div>
      </div>
    </div>
  );

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Hakedişler</h2>
        <div className="flex items-center gap-4">
          <div className="text-sm text-gray-500">
            Teklifli hakediş için{' '}
            <span className="text-blue-600 cursor-pointer hover:underline" onClick={() => navigate('/quotes')}>
              Teklifler
            </span>{' '}
            sayfasını kullanın
          </div>
          <button onClick={() => navigate('/hakedisler/sablonlar')}
            className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 font-medium text-sm">
            📑 Şablonlar
          </button>
          <button onClick={() => navigate('/hakedisler/yeni')}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium text-sm">
            + Teklifsiz Hakediş
          </button>
        </div>
      </div>

      {hakedisler.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-12 text-center text-gray-400">
          <div className="text-4xl mb-3">📋</div>
          <div>Henüz hakediş oluşturulmamış</div>
          <button onClick={() => navigate('/hakedisler/yeni')} className="mt-4 text-blue-600 hover:underline text-sm">
            Teklifsiz hakediş oluştur →
          </button>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Hakediş No</th>
                <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Teklif No</th>
                <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Müşteri</th>
                <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Proje</th>
                <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Tarih</th>
                <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Durum</th>
                <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">USD</th>
                <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">EUR</th>
                <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">TRY</th>
                <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">İşlemler</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {hakedisler.map(h => (
                <tr key={h.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-mono text-sm text-blue-600 font-medium">{h.hakedis_number}</td>
                  <td className="px-4 py-3 text-sm">
                    {h.quote_id ? (
                      <span className="text-gray-500 cursor-pointer hover:text-blue-600"
                        onClick={() => navigate(`/quotes/${h.quote_id}`)}>
                        {h.quote_number}
                      </span>
                    ) : (
                      <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded">Teklifsiz</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-gray-800 text-sm">{h.customer_name || '-'}</td>
                  <td className="px-4 py-3 text-gray-600 text-sm">{h.project_name || '-'}</td>
                  <td className="px-4 py-3 text-gray-600 text-sm">{h.hakedis_date}</td>
                  <td className="px-4 py-3">
                    {statusLabel(h.status)}
                    {h.location_name && <div className="text-xs text-gray-400 mt-1">{h.location_name}</div>}
                  </td>
                  <td className="px-4 py-3 text-right text-sm font-medium text-blue-700">
                    {h.subtotal_usd > 0 ? `$${h.subtotal_usd.toFixed(2)}` : '—'}
                  </td>
                  <td className="px-4 py-3 text-right text-sm font-medium text-purple-700">
                    {h.subtotal_eur > 0 ? `€${h.subtotal_eur.toFixed(2)}` : '—'}
                  </td>
                  <td className="px-4 py-3 text-right text-sm font-medium text-gray-800">
                    {h.subtotal_try > 0 ? `₺${h.subtotal_try.toFixed(2)}` : '—'}
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex flex-col gap-1.5">
                      <div className="flex gap-1.5 justify-end">
                        <ActionButton icon="edit" iconClass="text-blue-600" label="Düzenle" onClick={() => navigate(`/hakedisler/${h.id}`)} />
                        <ActionButton icon="pdf" iconClass="text-rose-600" label="PDF" onClick={() => handlePdf(h.id, h.hakedis_number, 'actual')} />
                        <ActionButton icon="excel" iconClass="text-green-700" label="Excel" onClick={() => handleExcel(h.id, h.hakedis_number, 'actual')} />
                      </div>
                      <div className="flex gap-1.5 justify-end">
                        {h.quote_id && (
                          <>
                            <ActionButton icon="pdf" iconClass="text-indigo-600" label="Karş. PDF" onClick={() => handlePdf(h.id, h.hakedis_number, 'comparison')} />
                            <ActionButton icon="excel" iconClass="text-teal-600" label="Karş. Excel" onClick={() => handleExcel(h.id, h.hakedis_number, 'comparison')} />
                          </>
                        )}
                        <ActionButton icon="trash" label="Sil" danger onClick={() => handleDelete(h)} />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
